import * as React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { getStyle } from './getStyle';
import * as Moment from 'moment';

export function getFooter(): JSX.Element {
    return <View fixed style={{ ...getStyle('footer') }}>
        <Text>
            {Moment().format('DD.MM.YYYY')}
        </Text>
        <Text fixed
            render={({ pageNumber, totalPages }) => {
                if (totalPages > 1) {
                    return `Seite | ${pageNumber}`;
                }
            }}
        />
    </View>;
}

